var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 37.5C8.39466 37.5 0 29.1052 0 18.75C0 8.39466 8.39466 0 18.75 0C29.1052 0 37.5 8.39466 37.5 18.75C37.5 29.1052 29.1052 37.5 18.75 37.5ZM18.75 33.75C27.0343 33.75 33.75 27.0343 33.75 18.75C33.75 10.4657 27.0343 3.75 18.75 3.75C10.4657 3.75 3.75 10.4657 3.75 18.75C3.75 27.0343 10.4657 33.75 18.75 33.75ZM16.875 9.375H20.625V13.125H16.875V9.375ZM16.875 16.875H20.625V28.125H16.875V16.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationLine);
export default __webpack_public_path__ + "static/media/information-line.98d3c53775d132a69a57c0c1e42ce6a2.svg";
export { ForwardRef as ReactComponent };